import { render, staticRenderFns } from "./SPage.vue?vue&type=template&id=12874739&"
import script from "./SPage.vue?vue&type=script&lang=js&"
export * from "./SPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports